module.exports = [{"type":"title","text":"2024-07-22"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續U本位：請求中的ClientOrderId字段會被系統自動轉為英文小寫。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-07-22.json
// module id = /chU
// module chunks = 3